import { useIntl } from 'react-intl';

type Params = Record<string, unknown>;

const useI18n = <T extends Record<string, string>>() => {
  const { formatMessage } = useIntl();

  const i18n = (id: ValuesOf<T>, params?: Params) =>
    formatMessage({ id }, params) as string;

  return {
    i18n,
    translate: i18n, // alias to ease migration both options work
  };
};

const translateAppName = (language, enableXingRebranding) => {
  const appName = require(`../../../i18n/onlyfy/locales/${language}`).messages;

  return enableXingRebranding
    ? `${appName['XSS_APP_TITLE']}`
    : `onlyfy ${appName['XSS_APP_TITLE']}`;
};

export { useI18n, translateAppName };
